import React, { useContext, useEffect } from 'react'
import ComponentTextString from "../forms/componentTextString"
import ComponentTextSelect from "../forms/componentTextSelect"
import ComponentTextMultiSelect from "../forms/componentTextMultiSelect"
import ComponentTextNumber from "../forms/componentTextNumber"
import ComponentTextInputDate from "../forms/componentTextInputDate"
import ComponentGenderRadioFormGroup from "../forms/componentGenderRadioFormGroup"
import ComponentTextParagraph from "../forms/componentTextParagraph"
import ComponentTextSimpleRadioGroup from "../forms/componentTextSimpleRadioGroup"
import RepeatableComponentTextString from "../forms/repetableComponents/repeatableComponentTextString"
import ComponentFormPortfolioFields from "../forms/ComponentFormPortfolioFields"
import RepeatableComponentTextSelect from "../forms/repetableComponents/repeatableComponentTextSelect"
import RepeatableComponentTextNumber from "../forms/repetableComponents/repeatableComponentTextNumber"
import RepeatableComponentTextInputDate from "../forms/repetableComponents/repeatableComponentTextInputDate"
import RepeatableComponentGenderRadioFormGroup from "../forms/repetableComponents/repeatableComponentGenderRadioFormGroup"
import RepeatableComponentTextSimpleRadioGroup from "../forms/repetableComponents/repeatableComponentTextSimpleRadioGroup"
import * as lookup from "../../../static/lookup.json"
import ComponentRadioFormGroup3 from "../forms/componentRadioFormGroup3"
import ComponentUpload from "../forms/componentUpload"
import ComponentTextCreatableSelect from "../forms/componentTextCreatableSelect"
import ComponentCheckboxFormGroup from '../forms/ComponentCheckboxFormGroup'
import ComponentCheckboxSingleFormGroup from '../forms/componentCheckboxSingleFG'
import StapiComponentTextSimpleRadioGroup from "../forms/strapiDrivenProductComponents/strapiComponentTextSimpleRadioGroup"
import * as keywordMapping from "../../../static/nvestKeyMapping.json"

//product components
import ComponentProductSimpleRadioGroup from "../forms/productComponents/componentProductSimpleRadioGroup"
import ComponentProductSelect from "../forms/productComponents/componentProductSelect"
import { ConditionContext } from "../context/conditionContext"
import { JourneyContext } from '../context/journeyContext'
import { ErrorContext } from "../context/errorContext"
import {SectionContext} from "../context/sectionContext"
import { componentRenderCheck, multiConditionComponentRenderCheck, repeatableMultiConditionComponentRenderCheck } from "../services/componentRenderCheck"
import ComponentButton from '../forms/ComponentButton'
import ComponentBannarGSP from '../forms/ComponentBannarGSP'
import ComponentBannarFlexiEdge from "../forms/componentBannerFlexiEdge"
import ComponentCheckbox from '../forms/ComponentLinkCheckbox'
export default function ComponentGroup(props) {
    //console.log("comppropssss",props,props.journeyIdFromStrapi);
    const [conditionState,setConditionState] = useContext(ConditionContext)
    const [journeyState,setJourneyState] = useContext(JourneyContext)
    const [errorState, setErrorState] = useContext(ErrorContext)
    const [sectionState, setSectionState] = useContext(SectionContext)
    const sectionIdForProductPage = [
        "CPCustomizePlanSection",
        "CPSpouseCoverDetails",
        "CPOptionInBuiltCoversSection",
        "iSelect360CPCustomizePlanSection",
        "iSelect360CPSpouseCoverDetails",
        "iSelect360CPOptionalInBuilt",
        "SectionGuaranteedSavingInvestmentDetails",
        "sectionFlexiEdgeCustomizeYourPlan",
        "CFSectionInvestmentDetails",
        "AlphaWealthPlanInvestmentDetailsSection",
        "SectionGuaranteedSavingsChooseGuranteedSum",
        "SectionGuaranteedIncomeChooseGuaranteedSumAssured",
        "SectionJeevanNiveshChooseYourGuaranteedSumAssured",
        "SectionInvest4GInvestmentDetails",
        "SectionSmartJuniorChooseGuaranteedSumAssured",
        "SectionSecureBhavishyaInvestmentDetails",
        "SectionGuaranteedFortuneCustomizeYourPlan",
        "SectionGuaranteedFutureSumAssured",
        "Promise4GrowthPlusInvestmentDetailsSection"
        // "SectionGuaranteedIncome4LifeChooseYourPlan"
    ]
    // to remove error for repeatable case
    useEffect(() => {
        const cleared = {};

        props.data.forEach(element => {
            if (
                (element.__typename === "ComponentCmpTagTextString" &&
                    element.conditions.length === 1 &&
                    props.repeatable &&
                    !componentRenderCheck(
                        element.conditions[0],
                        conditionState[element.conditions[0].watchKey],
                        journeyState
                    ))
                || (element.__typename === "ComponentCmpTagTextString" &&
                    element.conditions.length > 1 &&
                    props.repeatable &&
                    !multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState))
            ) {
                // Normalize formControlKey into an array
                const keys = Array.isArray(element.formControlKey)
                    ? element.formControlKey
                    : [element.formControlKey];

                keys.forEach((key, idx) => {
                    const errArr = errorState[key];
                    if (Array.isArray(errArr)) {
                        // Clear only the index matching this formControlKey
                        const newArr = errArr.map((v, i) => (i === idx ? "" : v));
                        // Only update if there's actually a change
                        if (newArr[idx] !== errArr[idx]) {
                            cleared[key] = newArr;
                        }
                    }
                });
            }
            if (
                (element.__typename === "ComponentCmpTagNumber" &&
                    element.conditions.length === 1 &&
                    props.repeatable &&
                    !componentRenderCheck(
                        element.conditions[0],
                        conditionState[element.conditions[0].watchKey],
                        journeyState
                    ))
                || (element.__typename === "ComponentCmpTagNumber" &&
                    element.conditions.length > 1 &&
                    props.repeatable &&
                    !multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState))
            ) {
                // Normalize formControlKey into an array
                const keys = Array.isArray(element.formControlKey)
                    ? element.formControlKey
                    : [element.formControlKey];

                keys.forEach((key, idx) => {
                    const errArr = errorState[key];
                    if (Array.isArray(errArr)) {
                        // Clear only the index matching this formControlKey
                        const newArr = errArr.map((v, i) => (i === idx ? "" : v));
                        // Only update if there's actually a change
                        if (newArr[idx] !== errArr[idx]) {
                            cleared[key] = newArr;
                        }
                    }
                });
            }
            if (
                (element.__typename === "ComponentCmpTagSelectFg" &&
                    element.conditions.length === 1 &&
                    props.repeatable &&
                    !componentRenderCheck(
                        element.conditions[0],
                        conditionState[element.conditions[0].watchKey],
                        journeyState
                    ))
                || (element.__typename === "ComponentCmpTagSelectFg" &&
                    element.conditions.length > 1 &&
                    props.repeatable &&
                    !multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState))
            ) {
                // Normalize formControlKey into an array
                const keys = Array.isArray(element.formControlKey)
                    ? element.formControlKey
                    : [element.formControlKey];

                keys.forEach((key, idx) => {
                    const errArr = errorState[key];
                    if (Array.isArray(errArr)) {
                        // Clear only the index matching this formControlKey
                        const newArr = errArr.map((v, i) => (i === idx ? "" : v));
                        // Only update if there's actually a change
                        if (newArr[idx] !== errArr[idx]) {
                            cleared[key] = newArr;
                        }
                    }
                });
            }

        });

        if (Object.keys(cleared).length > 0) {
            setErrorState(prev => ({ ...prev, ...cleared }));
        }
    }, [props.data, conditionState, journeyState, errorState]);

    return (
        <>
            {
            sectionIdForProductPage.includes(props.sectionId)
            ?
                props.data.map((element, i) => {
                    if (element['__typename'] === "ComponentCmpTagTextString") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextString key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi} channel={props.channel} />
                                    </div>

                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else if (element.conditions.length > 1) {
                            if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextString key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi} channel={props.channel} />
                                    </div>

                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentTextString key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                                
                            )
                        }
                    }
                    
                    else if (element['__typename'] === "ComponentCmpTagSelectFg") {
                        let optionNameInMappingJson = keywordMapping[props.journeyIdFromStrapi][`${props.pageId}.${props.sectionId}.${props.data[i].formControlKey}`]
                        let requiredObjectInNvestFilterResult = props.nvestFilterResult?.formInputs.filter(element => element.unified_keywordName === optionNameInMappingJson)
                        let parentUnifiedkeyofProposalJSON = requiredObjectInNvestFilterResult?.[0]?.listItems?.[0]?.ParentUnifiedkeyofProposalJSON
                        let watchKey
                        if(parentUnifiedkeyofProposalJSON){
                            watchKey = Object.keys(keywordMapping[props.journeyIdFromStrapi]).find(element => keywordMapping[props.journeyIdFromStrapi][element].toLowerCase() === parentUnifiedkeyofProposalJSON.toLowerCase())
                        }
                        if(props.sectionId === "sectionFlexiEdgeCustomizeYourPlan" 
                        && props.data[i].formControlKey === "FlexiCPPremiumPaymentTerm"){
                            watchKey = "PageFlexiEdgeCalculatePremium.sectionFlexiEdgeCustomizeYourPlan.FlexiCPPolicyTerm"
                        }
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentProductSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId}  watchKey={watchKey} nvestFilterResult={props.nvestFilterResult} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else if (element.conditions.length > 1) {
                            if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentProductSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId}  watchKey={watchKey} nvestFilterResult={props.nvestFilterResult} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentProductSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId}  watchKey={watchKey} nvestFilterResult={props.nvestFilterResult} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                        
                    }
                    
                    else if (element['__typename'] === "ComponentCmpTagCsfg") {
                        let optionNameInMappingJson = keywordMapping[props.journeyIdFromStrapi][`${props.pageId}.${props.sectionId}.${props.data[i].formControlKey}`]
                        let requiredObjectInNvestFilterResult = props.nvestFilterResult?.formInputs.filter(element => element.unified_keywordName === optionNameInMappingJson)
                        let parentUnifiedkeyofProposalJSON = requiredObjectInNvestFilterResult?.[0]?.listItems?.[0]?.ParentUnifiedkeyofProposalJSON
                        let watchKey
                        if(parentUnifiedkeyofProposalJSON){
                            let keyInNvestToCheck
                            if(parentUnifiedkeyofProposalJSON.includes(",")){
                                let temp = parentUnifiedkeyofProposalJSON.split(",")
                                keyInNvestToCheck = temp[0]
                            }else{
                                keyInNvestToCheck = parentUnifiedkeyofProposalJSON
                            }
                            watchKey = Object.keys(keywordMapping[props.journeyIdFromStrapi]).find(element => keywordMapping[props.journeyIdFromStrapi][element].toLowerCase() === keyInNvestToCheck.toLowerCase())
                        }
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextCreatableSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId}  watchKey={watchKey} nvestFilterResult={props.nvestFilterResult} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel} firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall} setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else if (element.conditions.length > 1) {
                            if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextCreatableSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId}  watchKey={watchKey} nvestFilterResult={props.nvestFilterResult} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel} firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall} setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentTextCreatableSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId}  watchKey={watchKey} nvestFilterResult={props.nvestFilterResult} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel} firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall} setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}  />
                                </div>
                            )
                        }
                        
                    }
                    else if (element['__typename'] === "ComponentCmpTagNumber") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextNumber key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else if (element.conditions.length > 1) {
                            if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextNumber key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentTextNumber key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                        
                    }
                    else if (element['__typename'] === "ComponentCmpTagInputDate") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextInputDate key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else if (element.conditions.length > 1) {
                            if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextInputDate key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentTextInputDate key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                        
                    }
                    else if (element['__typename'] === "ComponentCmpTagCbfg") {
                        let optionNameInMappingJson = keywordMapping[props.journeyIdFromStrapi][`${props.pageId}.${props.sectionId}.${props.data[i].formControlKey}`]
                        let requiredObjectInNvestFilterResult = props.nvestFilterResult?.formInputs.filter(element => element.unified_keywordName === optionNameInMappingJson)
                        let parentUnifiedkeyofProposalJSON = requiredObjectInNvestFilterResult?.[0]?.listItems?.[0]?.ParentUnifiedkeyofProposalJSON
                        let watchKey
                        if(parentUnifiedkeyofProposalJSON){
                            watchKey = Object.keys(keywordMapping[props.journeyIdFromStrapi]).find(element => {
                                // console.log(keywordMapping[props.journeyIdFromStrapi][element], props.data[i].formControlKey)
                                if(typeof keywordMapping[props.journeyIdFromStrapi][element] === "string"){
                                    return keywordMapping[props.journeyIdFromStrapi][element].toLowerCase() === parentUnifiedkeyofProposalJSON.toLowerCase()
                                }  
                            }
                            )
                        }
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                return (
                                    <ComponentCheckboxFormGroup key={i} data={props.data[i]} indexForKey={i} elementClass={element.class} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} watchKey={watchKey} nvestFilterResult={props.nvestFilterResult} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else if (element.conditions.length > 1) {
                            if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                return (
                                    <ComponentCheckboxFormGroup key={i} data={props.data[i]} indexForKey={i} elementClass={element.class} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} watchKey={watchKey} nvestFilterResult={props.nvestFilterResult} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else {
                            return (
                                <ComponentCheckboxFormGroup key={i} data={props.data[i]} indexForKey={i} elementClass={element.class} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} watchKey={watchKey} nvestFilterResult={props.nvestFilterResult} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                            )
                        }
                        
                    }
                    
                    else if (element['__typename'] === "ComponentCmpTagRadioFrmGrp") {
                        if(element["formControlKey"].toLowerCase().includes("gender") || element["formControlKey"].toLowerCase().includes("smoke")){
                            if (element.conditions.length === 1) {
                                if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <ComponentGenderRadioFormGroup key={i} data={props.data[i]} sectionId={props.sectionId} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                        </div>
                                    )
                                } else {
                                    if (errorState[element.formControlKey]) {
                                        setErrorState((prev) => {
                                            return ({
                                                ...prev,
                                                [element.formControlKey]: ""
                                            })
                                        })
                                    }
                                    if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                        setSectionState((prev) => {
                                            return ({
                                                ...prev,
                                                sectionData: {
                                                    ...prev.sectionData,
                                                    [element.formControlKey]: ""
                                                }
                                            })
                                        })
                                    }
                                }
                            } else if (element.conditions.length > 1) {
                                if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <ComponentGenderRadioFormGroup key={i} data={props.data[i]} sectionId={props.sectionId} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                        </div>
                                    )
                                } else {
                                    if (errorState[element.formControlKey]) {
                                        setErrorState((prev) => {
                                            return ({
                                                ...prev,
                                                [element.formControlKey]: ""
                                            })
                                        })
                                    }
                                    if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                        setSectionState((prev) => {
                                            return ({
                                                ...prev,
                                                sectionData: {
                                                    ...prev.sectionData,
                                                    [element.formControlKey]: ""
                                                }
                                            })
                                        })
                                    }
                                }
                            } else {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentGenderRadioFormGroup key={i} data={props.data[i]} sectionId={props.sectionId} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            }
                            
                        }
                        else if(element["isProductDerivedFromStrapi"]){
                            if (element.conditions.length === 1) {
                                if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <StapiComponentTextSimpleRadioGroup key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                        </div>
                                    )
                                } else {
                                    if (errorState[element.formControlKey]) {
                                        setErrorState((prev) => {
                                            return ({
                                                ...prev,
                                                [element.formControlKey]: ""
                                            })
                                        })
                                    }
                                    if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                        setSectionState((prev) => {
                                            return ({
                                                ...prev,
                                                sectionData: {
                                                    ...prev.sectionData,
                                                    [element.formControlKey]: ""
                                                }
                                            })
                                        })
                                    }
                                }
                            } else if (element.conditions.length > 1) {
                                if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <StapiComponentTextSimpleRadioGroup key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                        </div>
                                    )
                                } else {
                                    if (errorState[element.formControlKey]) {
                                        setErrorState((prev) => {
                                            return ({
                                                ...prev,
                                                [element.formControlKey]: ""
                                            })
                                        })
                                    }
                                    if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                        setSectionState((prev) => {
                                            return ({
                                                ...prev,
                                                sectionData: {
                                                    ...prev.sectionData,
                                                    [element.formControlKey]: ""
                                                }
                                            })
                                        })
                                    }
                                }
                            } else {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <StapiComponentTextSimpleRadioGroup key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            }
                        }else {
                            let optionNameInMappingJson = keywordMapping[props.journeyIdFromStrapi][`${props.pageId}.${props.sectionId}.${props.data[i].formControlKey}`]
                            let requiredObjectInNvestFilterResult = props.nvestFilterResult?.formInputs.filter(element => element.unified_keywordName === optionNameInMappingJson)
                            let parentUnifiedkeyofProposalJSON = requiredObjectInNvestFilterResult?.[0]?.listItems?.[0]?.ParentUnifiedkeyofProposalJSON
                            let watchKey
                            if(parentUnifiedkeyofProposalJSON){
                                watchKey = Object.keys(keywordMapping[props.journeyIdFromStrapi]).find(element => {
                                    if(typeof keywordMapping[props.journeyIdFromStrapi][element] === "string"){
                                        return keywordMapping[props.journeyIdFromStrapi][element].toLowerCase() === parentUnifiedkeyofProposalJSON.toLowerCase()
                                    } 
                                })
                            }
                            if (element.conditions.length === 1) {
                                if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                    return (
                                        <ComponentProductSimpleRadioGroup key={i} data={props.data[i]} indexForKey={i} elementClass={element.class} sectionId={props.sectionId} pageId={props.pageId} nvestFilterResult={props.nvestFilterResult} watchKey={watchKey} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    )
                                } else {
                                    if (errorState[element.formControlKey]) {
                                        setErrorState((prev) => {
                                            return ({
                                                ...prev,
                                                [element.formControlKey]: ""
                                            })
                                        })
                                    }
                                    if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                        setSectionState((prev) => {
                                            return ({
                                                ...prev,
                                                sectionData: {
                                                    ...prev.sectionData,
                                                    [element.formControlKey]: ""
                                                }
                                            })
                                        })
                                    }
                                }
                            } else if (element.conditions.length > 1) {
                                if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                    return (
                                        <ComponentProductSimpleRadioGroup key={i} data={props.data[i]} indexForKey={i} elementClass={element.class} sectionId={props.sectionId} pageId={props.pageId} nvestFilterResult={props.nvestFilterResult} watchKey={watchKey} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    )
                                } else {
                                    if (errorState[element.formControlKey]) {
                                        setErrorState((prev) => {
                                            return ({
                                                ...prev,
                                                [element.formControlKey]: ""
                                            })
                                        })
                                    }
                                    if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                        setSectionState((prev) => {
                                            return ({
                                                ...prev,
                                                sectionData: {
                                                    ...prev.sectionData,
                                                    [element.formControlKey]: ""
                                                }
                                            })
                                        })
                                    }
                                }
                            } else {
                                return (
                                    <ComponentProductSimpleRadioGroup key={i} data={props.data[i]} indexForKey={i} elementClass={element.class} sectionId={props.sectionId} pageId={props.pageId} nvestFilterResult={props.nvestFilterResult} watchKey={watchKey} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                )
                            }
                            
                        }  
                    }
                    else if (element['__typename'] === "ComponentCmpTagText") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextParagraph key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else if (element.conditions.length > 1) {
                            if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextParagraph key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentTextParagraph key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                        
                    }
                    else if (element['__typename'] === "ComponentComponentTagsRadioFormGroup3") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                return(
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentRadioFormGroup3 key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else if (element.conditions.length > 1) {
                            if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                return(
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentRadioFormGroup3 key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else {
                            return(
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentRadioFormGroup3 key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                        
                    }
                    else if (element['__typename'] === "ComponentCmpTagButton" && element["display"]) {
                        return (
                            <div className={`field ${element.class}`} key={props.sectionId + i}>
                                <ComponentButton key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} setShowError={props.setShowError} pageId={props.pageId} showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan} setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan} journeyIdFromStrapi={props.journeyIdFromStrapi} channel={props.channel} pages={props.pages} currentSectionIndex={props.currentSectionIndex} currentPageIndex={props.currentPageIndex} sections={props.sections} />
                            </div>

                        )
                    }
                    else if (element['__typename'] === "ComponentCmpTagBgsp") {
                        return (
                            <div className={`field ${element.class}`} key={props.sectionId + i}>
                                <ComponentBannarGSP key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi} channel={props.channel} />
                            </div>
                        )
                    }
                    else if (element['__typename'] === "ComponentCmpTagBfe") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentBannarFlexiEdge key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else if (element.conditions.length > 1) {
                            if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentBannarFlexiEdge key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentBannarFlexiEdge key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                        
                    }
                    else if (element['__typename'] === "ComponentCmpTagCbmfg") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentCheckboxSingleFormGroup key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else if (element.conditions.length > 1) {
                            if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentCheckboxSingleFormGroup key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentCheckboxSingleFormGroup key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                        
                    }
                    else if (element['__typename'] === "ComponentCmpTagLinkCb" && element["display"]) {
                        return (
                            <div className={`field ${element.class}`} key={props.sectionId + i}>
                                <ComponentCheckbox key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi} channel={props.channel} />
                            </div>
                        )
                    }
                    else if (element['__typename'] === "ComponentCmpTagFileUpload") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                return(
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentUpload key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else if (element.conditions.length > 1) {
                            if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                return(
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentUpload key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                if (errorState[element.formControlKey]) {
                                    setErrorState((prev) => {
                                        return ({
                                            ...prev,
                                            [element.formControlKey]: ""
                                        })
                                    })
                                }
                                if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                    setSectionState((prev) => {
                                        return ({
                                            ...prev,
                                            sectionData: {
                                                ...prev.sectionData,
                                                [element.formControlKey]: ""
                                            }
                                        })
                                    })
                                }
                            }
                        } else {
                            return(
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentUpload key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                    }
                    return (<></>)
                })

            :

             props.repeatable 
            
            ?
                //repeatable components
                props.data.map((element, i) => {
                    if (element['__typename'] === "ComponentCmpTagTextString") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey]?.[props.index], journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <RepeatableComponentTextString key={i + props.index} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} repeatable={props.repeatable} index={props.index} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                    
                                )
                            } else {
                                // if (errorState[element.formControlKey]) {
                                //     let temp = errorState[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setErrorState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             [element.formControlKey]: temp
                                //         })
                                //     })
                                // }
                                // if (sectionState.sectionData?.[element.formControlKey]) {
                                //     let temp = sectionState.sectionData[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setSectionState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             sectionData: {
                                //                 ...prev.sectionData,
                                //                 [element.formControlKey]: temp
                                //             }
                                //         })
                                //     })
                                // }
                            }
                        } else if (element.conditions.length > 1) {
                            if (repeatableMultiConditionComponentRenderCheck(element.conditions, conditionState, journeyState, props.index)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <RepeatableComponentTextString key={i + props.index} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} repeatable={props.repeatable} index={props.index} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                    
                                )
                            } else {
                                // if (errorState[element.formControlKey]) {
                                //     let temp = errorState[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setErrorState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             [element.formControlKey]: temp
                                //         })
                                //     })
                                // }
                                // if (sectionState.sectionData?.[element.formControlKey]) {
                                //     let temp = sectionState.sectionData[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setSectionState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             sectionData: {
                                //                 ...prev.sectionData,
                                //                 [element.formControlKey]: temp
                                //             }
                                //         })
                                //     })
                                // }
                            }
                        } else {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <RepeatableComponentTextString key={i + props.index} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} repeatable={props.repeatable} index={props.index} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                                
                            )
                        }
                       
                    }
                    else if (element['__typename'] === "ComponentCmpTagSelectFg") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey]?.[props.index], journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <RepeatableComponentTextSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} pageId={props.pageId} showError={props.showError} repeatable={props.repeatable} index={props.index} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                // if (errorState[element.formControlKey]) {
                                //     let temp = errorState[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setErrorState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             [element.formControlKey]: temp
                                //         })
                                //     })
                                // }
                                // if (sectionState.sectionData?.[element.formControlKey]) {
                                //     let temp = sectionState.sectionData[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setSectionState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             sectionData: {
                                //                 ...prev.sectionData,
                                //                 [element.formControlKey]: temp
                                //             }
                                //         })
                                //     })
                                // }
                            }
                        } else if (element.conditions.length > 1) {
                            if (repeatableMultiConditionComponentRenderCheck(element.conditions, conditionState, journeyState, props.index)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <RepeatableComponentTextSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} pageId={props.pageId} showError={props.showError} repeatable={props.repeatable} index={props.index} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                ) 
                            } else {
                                // if (errorState[element.formControlKey]) {
                                //     let temp = errorState[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setErrorState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             [element.formControlKey]: temp
                                //         })
                                //     })
                                // }
                                // if (sectionState.sectionData?.[element.formControlKey]) {
                                //     let temp = sectionState.sectionData[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setSectionState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             sectionData: {
                                //                 ...prev.sectionData,
                                //                 [element.formControlKey]: temp
                                //             }
                                //         })
                                //     })
                                // }
                            }
                        } else {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <RepeatableComponentTextSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} pageId={props.pageId} showError={props.showError} repeatable={props.repeatable} index={props.index} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            ) 
                        }
                    }
                    else if (element['__typename'] === "ComponentCmpTagNumber") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey]?.[props.index], journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <RepeatableComponentTextNumber key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} repeatable={props.repeatable} index={props.index} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                // if (errorState[element.formControlKey]) {
                                //     let temp = errorState[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setErrorState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             [element.formControlKey]: temp
                                //         })
                                //     })
                                // }
                                // if (sectionState.sectionData?.[element.formControlKey]) {
                                //     let temp = sectionState.sectionData[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setSectionState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             sectionData: {
                                //                 ...prev.sectionData,
                                //                 [element.formControlKey]: temp
                                //             }
                                //         })
                                //     })
                                // }
                            }
                        } else if (element.conditions.length > 1) {
                            if (repeatableMultiConditionComponentRenderCheck(element.conditions, conditionState, journeyState, props.index)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <RepeatableComponentTextNumber key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} repeatable={props.repeatable} index={props.index} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                // if (errorState[element.formControlKey]) {
                                //     let temp = errorState[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setErrorState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             [element.formControlKey]: temp
                                //         })
                                //     })
                                // }
                                // if (sectionState.sectionData?.[element.formControlKey]) {
                                //     let temp = sectionState.sectionData[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setSectionState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             sectionData: {
                                //                 ...prev.sectionData,
                                //                 [element.formControlKey]: temp
                                //             }
                                //         })
                                //     })
                                // }
                            }
                        } else {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <RepeatableComponentTextNumber key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} repeatable={props.repeatable} index={props.index} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                       
                    }
                    else if (element['__typename'] === "ComponentCmpTagInputDate") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey]?.[props.index], journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <RepeatableComponentTextInputDate key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} repeatable={props.repeatable} index={props.index} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                // if (errorState[element.formControlKey]) {
                                //     let temp = errorState[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setErrorState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             [element.formControlKey]: temp
                                //         })
                                //     })
                                // }
                                // if (sectionState.sectionData?.[element.formControlKey]) {
                                //     let temp = sectionState.sectionData[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setSectionState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             sectionData: {
                                //                 ...prev.sectionData,
                                //                 [element.formControlKey]: temp
                                //             }
                                //         })
                                //     })
                                // }
                            }
                        } else if (element.conditions.length > 1) {
                            if (repeatableMultiConditionComponentRenderCheck(element.conditions, conditionState, journeyState, props.index)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <RepeatableComponentTextInputDate key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} repeatable={props.repeatable} index={props.index} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                // if (errorState[element.formControlKey]) {
                                //     let temp = errorState[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setErrorState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             [element.formControlKey]: temp
                                //         })
                                //     })
                                // }
                                // if (sectionState.sectionData?.[element.formControlKey]) {
                                //     let temp = sectionState.sectionData[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setSectionState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             sectionData: {
                                //                 ...prev.sectionData,
                                //                 [element.formControlKey]: temp
                                //             }
                                //         })
                                //     })
                                // }
                            }
                        } else {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <RepeatableComponentTextInputDate key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} repeatable={props.repeatable} index={props.index} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                        
                    }
                    else if (element['__typename'] === "ComponentCmpTagRadioFrmGrp") {
                        if(element["formControlKey"].toLowerCase().includes("gender")|| element["formControlKey"].toLowerCase().includes("smoke")){
                            if (element.conditions.length === 1) {
                                if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey]?.[props.index], journeyState)) {
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <RepeatableComponentGenderRadioFormGroup key={i} data={props.data[i]} sectionId={props.sectionId} repeatable={props.repeatable} index={props.index} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                        </div>
                                    )
                                } else {
                                    // if (errorState[element.formControlKey]) {
                                    //     let temp = errorState[element.formControlKey]
                                    //     temp[props.index] = ""
                                    //     setErrorState((prev) => {
                                    //         return ({
                                    //             ...prev,
                                    //             [element.formControlKey]: temp
                                    //         })
                                    //     })
                                    // }
                                    // if (sectionState.sectionData?.[element.formControlKey]) {
                                    //     let temp = sectionState.sectionData[element.formControlKey]
                                    //     temp[props.index] = ""
                                    //     setSectionState((prev) => {
                                    //         return ({
                                    //             ...prev,
                                    //             sectionData: {
                                    //                 ...prev.sectionData,
                                    //                 [element.formControlKey]: temp
                                    //             }
                                    //         })
                                    //     })
                                    // }
                                }
                            } else if (element.conditions.length > 1) {
                                if (repeatableMultiConditionComponentRenderCheck(element.conditions, conditionState, journeyState, props.index)) {
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <RepeatableComponentGenderRadioFormGroup key={i} data={props.data[i]} sectionId={props.sectionId} repeatable={props.repeatable} index={props.index} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                        </div>
                                    )
                                } else {
                                    // if (errorState[element.formControlKey]) {
                                    //     let temp = errorState[element.formControlKey]
                                    //     temp[props.index] = ""
                                    //     setErrorState((prev) => {
                                    //         return ({
                                    //             ...prev,
                                    //             [element.formControlKey]: temp
                                    //         })
                                    //     })
                                    // }
                                    // if (sectionState.sectionData?.[element.formControlKey]) {
                                    //     let temp = sectionState.sectionData[element.formControlKey]
                                    //     temp[props.index] = ""
                                    //     setSectionState((prev) => {
                                    //         return ({
                                    //             ...prev,
                                    //             sectionData: {
                                    //                 ...prev.sectionData,
                                    //                 [element.formControlKey]: temp
                                    //             }
                                    //         })
                                    //     })
                                    // }
                                }
                            } else {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <RepeatableComponentGenderRadioFormGroup key={i} data={props.data[i]} sectionId={props.sectionId} repeatable={props.repeatable} index={props.index} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            }
                            
                        }
                        else {
                            if (element.conditions.length === 1) {
                                if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey]?.[props.index], journeyState)) {
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <RepeatableComponentTextSimpleRadioGroup key={i} data={props.data[i]} sectionId={props.sectionId} pageId={props.pageId} repeatable={props.repeatable} index={props.index} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                        </div>
                                    )
                                } else {
                                    // if (errorState[element.formControlKey]) {
                                    //     let temp = errorState[element.formControlKey]
                                    //     temp[props.index] = ""
                                    //     setErrorState((prev) => {
                                    //         return ({
                                    //             ...prev,
                                    //             [element.formControlKey]: temp
                                    //         })
                                    //     })
                                    // }
                                    // if (sectionState.sectionData?.[element.formControlKey]) {
                                    //     let temp = sectionState.sectionData[element.formControlKey]
                                    //     temp[props.index] = ""
                                    //     setSectionState((prev) => {
                                    //         return ({
                                    //             ...prev,
                                    //             sectionData: {
                                    //                 ...prev.sectionData,
                                    //                 [element.formControlKey]: temp
                                    //             }
                                    //         })
                                    //     })
                                    // }
                                }
                            } else if (element.conditions.length > 1) {
                                if (repeatableMultiConditionComponentRenderCheck(element.conditions, conditionState, journeyState, props.index)) {
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <RepeatableComponentTextSimpleRadioGroup key={i} data={props.data[i]} sectionId={props.sectionId} pageId={props.pageId} repeatable={props.repeatable} index={props.index} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                        </div>
                                    )
                                } else {
                                    // if (errorState[element.formControlKey]) {
                                    //     let temp = errorState[element.formControlKey]
                                    //     temp[props.index] = ""
                                    //     setErrorState((prev) => {
                                    //         return ({
                                    //             ...prev,
                                    //             [element.formControlKey]: temp
                                    //         })
                                    //     })
                                    // }
                                    // if (sectionState.sectionData?.[element.formControlKey]) {
                                    //     let temp = sectionState.sectionData[element.formControlKey]
                                    //     temp[props.index] = ""
                                    //     setSectionState((prev) => {
                                    //         return ({
                                    //             ...prev,
                                    //             sectionData: {
                                    //                 ...prev.sectionData,
                                    //                 [element.formControlKey]: temp
                                    //             }
                                    //         })
                                    //     })
                                    // }
                                }
                            } else {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <RepeatableComponentTextSimpleRadioGroup key={i} data={props.data[i]} sectionId={props.sectionId} pageId={props.pageId} repeatable={props.repeatable} index={props.index} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            }
                            
                        }  
                    }
                    else if (element['__typename'] === "ComponentCmpTagText") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey]?.[props.index], journeyState)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextParagraph key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                // if (errorState[element.formControlKey]) {
                                //     let temp = errorState[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setErrorState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             [element.formControlKey]: temp
                                //         })
                                //     })
                                // }
                                // if (sectionState.sectionData?.[element.formControlKey]) {
                                //     let temp = sectionState.sectionData[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setSectionState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             sectionData: {
                                //                 ...prev.sectionData,
                                //                 [element.formControlKey]: temp
                                //             }
                                //         })
                                //     })
                                // }
                            }
                        } else if (element.conditions.length > 1) {
                            if (repeatableMultiConditionComponentRenderCheck(element.conditions, conditionState, journeyState, props.index)) {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextParagraph key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                // if (errorState[element.formControlKey]) {
                                //     let temp = errorState[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setErrorState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             [element.formControlKey]: temp
                                //         })
                                //     })
                                // }
                                // if (sectionState.sectionData?.[element.formControlKey]) {
                                //     let temp = sectionState.sectionData[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setSectionState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             sectionData: {
                                //                 ...prev.sectionData,
                                //                 [element.formControlKey]: temp
                                //             }
                                //         })
                                //     })
                                // }
                            }
                        } else {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentTextParagraph key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                        
                    }
                    else if (element['__typename'] === "ComponentComponentTagsRadioFormGroup3") {
                        if (element.conditions.length === 1) {
                            if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey]?.[props.index], journeyState)) {
                                return(
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentRadioFormGroup3 key={i} data={props.data[i]}  journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                // if (errorState[element.formControlKey]) {
                                //     let temp = errorState[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setErrorState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             [element.formControlKey]: temp
                                //         })
                                //     })
                                // }
                                // if (sectionState.sectionData?.[element.formControlKey]) {
                                //     let temp = sectionState.sectionData[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setSectionState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             sectionData: {
                                //                 ...prev.sectionData,
                                //                 [element.formControlKey]: temp
                                //             }
                                //         })
                                //     })
                                // }
                            }
                        } else if (element.conditions.length > 1) {
                            if (repeatableMultiConditionComponentRenderCheck(element.conditions, conditionState, journeyState, props.index)) {
                                return(
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentRadioFormGroup3 key={i} data={props.data[i]}  journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            } else {
                                // if (errorState[element.formControlKey]) {
                                //     let temp = errorState[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setErrorState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             [element.formControlKey]: temp
                                //         })
                                //     })
                                // }
                                // if (sectionState.sectionData?.[element.formControlKey]) {
                                //     let temp = sectionState.sectionData[element.formControlKey]
                                //     temp[props.index] = ""
                                //     setSectionState((prev) => {
                                //         return ({
                                //             ...prev,
                                //             sectionData: {
                                //                 ...prev.sectionData,
                                //                 [element.formControlKey]: temp
                                //             }
                                //         })
                                //     })
                                // }
                            }
                        } else {
                            return(
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentRadioFormGroup3 key={i} data={props.data[i]}  journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                     
                    } 
                    else if (element['__typename'] === "ComponentCmpTagLinkCb" && element["display"]) {
                        if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey]?.[props.index], journeyState)){
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentCheckbox key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi} channel={props.channel} />
                                </div>
                            )
                        }
                    }
                    return (<></>)
                })
                
                :
                    //normal components
                    props.data.map((element, i) => {
                        if (element['__typename'] === "ComponentCmpTagTextString") {
                            if (element.conditions.length === 1) {
                                if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                    let reqCondWatchKeys =  []
                                    if(props.data[i].not_rq_conds?.length )
                                    {
                                        if(props.data[i].not_rq_conds?.length==1)
                                        {
                                            reqCondWatchKeys.push(props.data[i].not_rq_conds[0].watchKey)
                                        }else{
                                            reqCondWatchKeys = props.data[i].not_rq_conds.map((condition) => {
                                                return condition.watchKey
                                            })
                                        }
                                    }
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <ComponentTextString key={i} data={props.data[i]} reqCondWatchKeys={reqCondWatchKeys} sectionId={props.sectionId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                        </div>
                                    )
                                } else {
                                    if (errorState[element.formControlKey]) {
                                        setErrorState((prev) => {
                                            return ({
                                                ...prev,
                                                [element.formControlKey]: ""
                                            })
                                        })
                                    }
                                    if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                        setSectionState((prev) => {
                                            return ({
                                                ...prev,
                                                sectionData: {
                                                    ...prev.sectionData,
                                                    [element.formControlKey]: ""
                                                }
                                            })
                                        })
                                    }
                                }
                            } else if (element.conditions.length > 1) {
                                if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                    let reqCondWatchKeys =  []
                                    if(props.data[i].not_rq_conds?.length )
                                    {
                                        if(props.data[i].not_rq_conds?.length==1)
                                        {
                                            reqCondWatchKeys.push(props.data[i].not_rq_conds[0].watchKey)
                                        }else{
                                            reqCondWatchKeys = props.data[i].not_rq_conds.map((condition) => {
                                                return condition.watchKey
                                            })
                                        }
                                    }
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <ComponentTextString key={i} data={props.data[i]} sectionId={props.sectionId} reqCondWatchKeys={reqCondWatchKeys} saveApplicationAndCallBi={props.saveApplicationAndCallBi} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                        </div>
                                    )
                                } else {
                                    if (errorState[element.formControlKey]) {
                                        setErrorState((prev) => {
                                            return ({
                                                ...prev,
                                                [element.formControlKey]: ""
                                            })
                                        })
                                    }
                                    if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                        setSectionState((prev) => {
                                            return ({
                                                ...prev,
                                                sectionData: {
                                                    ...prev.sectionData,
                                                    [element.formControlKey]: ""
                                                }
                                            })
                                        })
                                    }
                                }
                            } else {
                                let reqCondWatchKeys = []
                            if (props.data[i].not_rq_conds?.length) {
                                if (props.data[i].not_rq_conds?.length == 1) {
                                    reqCondWatchKeys.push(props.data[i].not_rq_conds[0].watchKey)
                                } else {
                                    reqCondWatchKeys = props.data[i].not_rq_conds.map((condition) => {
                                        return condition.watchKey
                                    })
                                }
                            }
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextString key={i} data={props.data[i]} sectionId={props.sectionId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} reqCondWatchKeys={reqCondWatchKeys} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            }
                        }
                        else if (element['__typename'] === "ComponentCmpTagButton" && element["display"]) {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentButton key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} setShowError={props.setShowError} pageId={props.pageId} showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan} setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan} journeyIdFromStrapi={props.journeyIdFromStrapi} channel={props.channel} />
                                </div>

                            )
                        }
                        else if (element['__typename'] === "ComponentCmpTagBgsp") {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentBannarGSP key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi} channel={props.channel} />
                                </div>

                            )
                        }
                        else if (element['__typename'] === "ComponentCmpTagLinkCb" && element["display"]) {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentCheckbox key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi} channel={props.channel} />
                                </div>
                            )
                        }
                        //  else if (element['__typename'] === "ComponentCmpGrpPf") {
                        //     return (
                        //         <div className={`field ${element.class}`} key={props.sectionId + i}>
                        //             <ComponentFormPortfolioFields key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}   />
                        //         </div>
                                
                        //     )
                        // }
                        else if (element['__typename'] === "ComponentCmpTagSelectFg") {
                            if (element.conditions.length === 1) {
                                let reqCondWatchKeys =  []
                                if(props.data[i].not_rq_conds?.length )
                                {
                                    if(props.data[i].not_rq_conds?.length==1)
                                    {
                                        reqCondWatchKeys.push(props.data[i].not_rq_conds[0].watchKey)
                                    }else{
                                        reqCondWatchKeys = props.data[i].not_rq_conds.map((condition) => {
                                            return condition.watchKey
                                        })
                                    }
                                }
                                if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <ComponentTextSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} reqCondWatchKeys={reqCondWatchKeys} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                            {/* <ComponentTextCreatableSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} /> */}
                                        </div>
                                    )
                                } else {
                                    if (errorState[element.formControlKey]) {
                                        setErrorState((prev) => {
                                            return ({
                                                ...prev,
                                                [element.formControlKey]: ""
                                            })
                                        })
                                    }
                                    if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                        setSectionState((prev) => {
                                            return ({
                                                ...prev,
                                                sectionData: {
                                                    ...prev.sectionData,
                                                    [element.formControlKey]: ""
                                                }
                                            })
                                        })
                                    }
                                }
                            } else if (element.conditions.length > 1) {
                                if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                    let reqCondWatchKeys =  []
                                    if(props.data[i].not_rq_conds?.length )
                                    {
                                        if(props.data[i].not_rq_conds?.length==1)
                                        {
                                            reqCondWatchKeys.push(props.data[i].not_rq_conds[0].watchKey)
                                        }else{
                                            reqCondWatchKeys = props.data[i].not_rq_conds.map((condition) => {
                                                return condition.watchKey
                                            })
                                        }
                                    }
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <ComponentTextSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} reqCondWatchKeys={reqCondWatchKeys} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                            {/* <ComponentTextCreatableSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} /> */}
                                        </div>
                                    )
                                } else {
                                    if (errorState[element.formControlKey]) {
                                        setErrorState((prev) => {
                                            return ({
                                                ...prev,
                                                [element.formControlKey]: ""
                                            })
                                        })
                                    }
                                    if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                        setSectionState((prev) => {
                                            return ({
                                                ...prev,
                                                sectionData: {
                                                    ...prev.sectionData,
                                                    [element.formControlKey]: ""
                                                }
                                            })
                                        })
                                    }
                                }
                            } else {
                                let reqCondWatchKeys = []
                                if (props.data[i].not_rq_conds?.length) {
                                    if (props.data[i].not_rq_conds?.length == 1) {
                                        reqCondWatchKeys.push(props.data[i].not_rq_conds[0].watchKey)
                                    } else {
                                        reqCondWatchKeys = props.data[i].not_rq_conds.map((condition) => {
                                            return condition.watchKey
                                        })
                                    }
                                }
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]] ? lookup[props.data[i]["lookupKey"]][0] : props.data[i].lookupKey[0]} reqCondWatchKeys={reqCondWatchKeys} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                        {/* <ComponentTextCreatableSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} /> */}
                                    </div>
                                )
                            }
                            
                        }

                        else if (element['__typename'] === "ComponentCmpTagMultiSelect") {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentTextMultiSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    {/* <ComponentTextCreatableSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} /> */}
                                </div>
                            )
                        }
                        
                        else if (element['__typename'] === "ComponentCmpTagCsfg") {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentTextCreatableSelect key={i} data={props.data[i]} options={lookup[props.data[i]["lookupKey"]][0]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel} firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall} setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}  />
                                </div>
                            )
                        }
                        else if (element['__typename'] === "ComponentCmpTagNumber") {
                            if (element.conditions.length === 1) {
                                if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <ComponentTextNumber key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                        </div>
                                    )
                                } else {
                                    if (errorState[element.formControlKey]) {
                                        setErrorState((prev) => {
                                            return ({
                                                ...prev,
                                                [element.formControlKey]: ""
                                            })
                                        })
                                    }
                                    if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                        setSectionState((prev) => {
                                            return ({
                                                ...prev,
                                                sectionData: {
                                                    ...prev.sectionData,
                                                    [element.formControlKey]: ""
                                                }
                                            })
                                        })
                                    }
                                }
                            } else if (element.conditions.length > 1) {
                                if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                                    return (
                                        <div className={`field ${element.class}`} key={props.sectionId + i}>
                                            <ComponentTextNumber key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                        </div>
                                    )
                                } else {
                                    if (errorState[element.formControlKey]) {
                                        setErrorState((prev) => {
                                            return ({
                                                ...prev,
                                                [element.formControlKey]: ""
                                            })
                                        })
                                    }
                                    if (sectionState.sectionData?.[element.formControlKey] && props.sectionId !== "residenceDetailsSection") {
                                        setSectionState((prev) => {
                                            return ({
                                                ...prev,
                                                sectionData: {
                                                    ...prev.sectionData,
                                                    [element.formControlKey]: ""
                                                }
                                            })
                                        })
                                    }
                                }
                            } else {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextNumber key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            }
                            
                        }
                        else if (element['__typename'] === "ComponentCmpTagInputDate") {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentTextInputDate key={i} data={props.data[i]} sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                        else if (element['__typename'] === "ComponentCmpTagRadioFrmGrp") {
                            if(element["formControlKey"].toLowerCase().includes("gender")  || element["formControlKey"].toLowerCase().includes("smoke")){
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentGenderRadioFormGroup key={i} data={props.data[i]} sectionId={props.sectionId} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div className={`field ${element.class}`} key={props.sectionId + i}>
                                        <ComponentTextSimpleRadioGroup key={i} data={props.data[i]} sectionId={props.sectionId} pageId={props.pageId} saveApplicationAndCallBi={props.saveApplicationAndCallBi} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                    </div>
                                )
                            }  
                        }
                        else if (element['__typename'] === "ComponentCmpTagCbfg") {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentCheckboxFormGroup key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                        else if (element['__typename'] === "ComponentCmpTagCbmfg") {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentCheckboxSingleFormGroup key={i} data={props.data[i]}  sectionId={props.sectionId} showError={props.showError} pageId={props.pageId} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
    
                        else if (element['__typename'] === "ComponentCmpTagText") {
                            return (
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentTextParagraph key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                        }
                        else if (element['__typename'] === "ComponentComponentTagsRadioFormGroup3") {
                            return(
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentRadioFormGroup3 key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                         
                        }
                        else if (element['__typename'] === "ComponentCmpTagFileUpload") {
                            return(
                                <div className={`field ${element.class}`} key={props.sectionId + i}>
                                    <ComponentUpload key={i} data={props.data[i]} journeyIdFromStrapi={props.journeyIdFromStrapi}  channel={props.channel}  />
                                </div>
                            )
                         
                        }
                        return (<></>)
                    })
            }
        </>
    )
}
